module.exports = __webpack_public_path__ + "30c9c043dbfad2563ef7d1331373b9eb.mp3";